var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0L27.6379 19.3053L34.689 1.29395L29.8047 20.0069L42.0726 5.06147L31.6493 21.3476L47.939 10.9232L32.9899 23.1924L51.701 18.3128L33.6914 25.3594L53 26.4974L33.6914 27.6407L51.701 34.6872L32.9899 29.8077L47.939 42.0768L31.6493 31.6524L42.0726 47.9385L29.8047 32.988L34.689 51.7061L27.6379 33.6947L26.5 53L25.362 33.6947L18.311 51.7061L23.1901 32.988L10.9221 47.9385L21.3455 31.6524L5.06098 42.0768L20.0101 29.8077L1.29902 34.6872L19.3034 27.6407L0 26.4974L19.3034 25.3594L1.29902 18.3128L20.0101 23.1924L5.06098 10.9232L21.3455 21.3476L10.9221 5.06147L23.1901 20.0069L18.311 1.29395L25.362 19.3053L26.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerLogo);
export default __webpack_public_path__ + "static/media/speaker-logo.b23fdf0dbff83359a64964df44e3797b.svg";
export { ForwardRef as ReactComponent };